import React from 'react'
import * as S from './styles'
import { ModalFooterProps } from './types'

export function ModalFooter({ children, ...props }: ModalFooterProps) {
  return (
    <S.Wrapper className="modal-footer" {...props}>
      {children}
    </S.Wrapper>
  )
}
